import { css } from 'styled-components'

const tertiaryButtonTemplate = () => css`
  background: var(--sl-bg-muted-plain);
  color: var(--sl-fg-muted);

  &:hover {
    background: var(--sl-bg-muted-plain-hover);
    color: var(--sl-fg-muted-hover);
  }

  &:focus-visible {
    box-shadow: var(--sl-focus-ring-base);
    background: var(--sl-bg-muted-plain-hover);
    color: var(--sl-fg-muted-hover);
  }

  &.active {
    color: var(--primary);

    &:hover {
      background: color-mix(in srgb, var(--primary) 5%, transparent);
    }

    &:focus-visible {
      background: color-mix(in srgb, var(--primary) 5%, transparent);
      box-shadow:
        0rem 0rem 0rem 0.0625rem var(--sl-color-gray-0),
        0rem 0rem 0rem 0.1875rem
          color-mix(in srgb, var(--primary) 40%, transparent);
    }
  }

  &:disabled {
    background: transparent;
    color: var(--sl-fg-base-disabled);
  }
`

export default tertiaryButtonTemplate
